import {
  usePermissionsStore,
  type Permission,
} from './stores/usePermissionsStore';

export function Can({
  permissions,
  children,
}: {
  permissions: Permission[];
  children: React.ReactNode;
}) {
  const { hasAnyPermission } = usePermissionsStore();

  if (hasAnyPermission(permissions)) {
    return children;
  }

  return null;
}

export const can = (permissionsToCheck: Permission[]) => {
  const { hasAnyPermission } = usePermissionsStore.getState();
  return hasAnyPermission(permissionsToCheck);
};
